<template>
    <div class='email-subscription'>
        <div class='email-subscription-container' v-if="!success">
            <div class="input-container">
                <el-input
                    :placeholder="$tc('emailSubscription.placeHolder')"
                    v-model="email"
                >
                    <template #append>
                        <button
                            class="button_clear subBtn"
                            :disabled= "submitting"
                            @click="submit"
                        >
                            {{ $t('emailSubscription.button') }}
                        </button>
                    </template>
                </el-input>
                <p class="error-message red" v-show="errorShow">{{ errorText }}</p>
            </div>
            <div class='checkbox-container'>
                <reo-checkbox
                    v-model="agreement"
                    size="middle"
                    :isRound="false"
                />
                <p class='agreement' v-if='!isTraffic' v-html="$t('emailSubscription.agreement')"></p>
                <p class='agreement' v-else v-html="$t('emailSubscription.agreementTraffic')"></p>
            </div>
        </div>
        <div class="success-content" v-else>
            <span class="icon-icon_have success-icon"></span><span>{{ $t('emailSubscription.successText') }}</span>
        </div>
    </div>
</template>

<script lang="ts">
import Vue from 'vue';
import { emailValidate, emailSubscribe } from '@/api/subscribe';
import { isEMailAddress } from '@/config/reg';
import { AxiosError } from 'axios';
import ReoCheckbox from './reoCheckbox.vue';
import { Input as ElInput } from 'element-ui';

export default Vue.extend({
    components: {
        ReoCheckbox,
        ElInput
    },
    props: {

        subject: String,
        isTraffic: {
            type: Boolean,
            default: false
        }

    },

    data () {

        return {

            email: '',
            errorShow: false,
            errorText: '',
            success: false,
            agreement: false,
            submitting: false

        };

    },

    methods: {

        showError ( textKey: string ): void {

            this.errorText = this.$tc( textKey );
            this.errorShow = true;

        },

        async submit (): Promise<boolean> {

            this.submitting = true;
            let email = this.email;
            this.errorShow = false;
            if ( !isEMailAddress( email )) {

                this.showError( 'errors.invalid_email' );
                this.submitting = false;
                return false;

            }
            if ( this.agreement ) {

                try {

                    let result = await emailValidate( email );

                    if ( result === 'invalid' ) {

                        this.showError( 'errors.invalid_email' );
                        this.submitting = false;
                        return false;

                    }

                } catch ( error ) {

                    this.submitting = false;
                    const symbol = ( error as AxiosError ).response?.data.error.symbol;
                    if ( symbol === 'invalid_parameters' ) {

                        this.showError( 'errors.invalid_email' );

                    }
                    return false;

                }
                try {

                    let result = await emailSubscribe( email, this.subject );
                    if ( result === 'ok' ) {

                        this.success = true;

                    }

                } catch ( err ) {

                    console.error( err );

                    const symbol = ( err as AxiosError ).response?.data.error.symbol;

                    switch ( symbol ) {

                        case 'subscription_exist': {

                            this.showError( 'errors.duplicate_submission' );
                            break;

                        }
                        case 'topic_not_exist':
                        default:
                            this.showError( 'errors.server_error' );

                    }
                    return false;

                } finally {

                    this.submitting = false;

                }
                return true;

            } else {

                this.submitting = false;
                this.showError( 'cloud.noVerify.notice_agree' );
                return false;

            }

        }

    }

});
</script>

<style lang="less" scoped>

.email-subscription-container{
    @media @pc {
        margin-bottom: .5rem;
    }

}
.checkbox-container{
    margin:0 auto;
    text-align: left;
    display: flex;
    .checkbox-left{
        padding-top:.03rem;
        @media @mobile{
            padding: 0;
        }

    }
    .agreement{
        color:#777777;
        font-size: 16px;
        line-height: 1.4;
        display: inline-block;
        margin-left: .08rem;
        @media @mobile{
            font-size: 14px;
            margin-left: .24rem;
        }
    }
}
.error-message{
    margin-top: 10px;
    margin:10px auto 0;
}
.title{
    margin-top: .5rem;
    font-size: 28px;
    font-weight: 500;
}

.success-content{
    margin-top: 0.3rem;
    margin-bottom: 0.38rem;
    font-size: 0.18rem;
    .success-icon{
        color: #59CA46;
        font-size: 0.22rem;
        margin-right: 0.12rem;
    }
    span{
        vertical-align: middle;
    }
}

.input-container{
    margin-top: 16px;
    @border-radius: 4px;
    /deep/ .el-input__inner{
        padding: 11px;
        font-size: 12px;
        font-weight: 500;
        line-height: 18px;
        background-color: @fill_tertiary;
        border-top-left-radius: @border-radius;
        border-bottom-left-radius: @border-radius;
        height: 40px;
        &:active{
            border-color: @b_6;
        }
    }
    /deep/ .el-input-group__append{
        padding: 0;
        border: none;
    }
    .subBtn{
        padding: 11px 15px;
        font-size: 12px;
        font-weight: 500;
        line-height: 18px;
        color: @white;
        background-color: @b_6;
        border-top-right-radius: @border-radius;
        border-bottom-right-radius: @border-radius;
        &:disabled{
            background-color: @b_disable;
        }
    }
    .agreement{
        display: flex;
        align-items: flex-start;
        gap: 8px;
        margin-top: 16px;
    }
}

@media screen and (max-width: 1199px) {
    .email-subscription{
        padding-right: .3rem;
    }
    .note{
        margin-left: 0;
        text-align: center;
        font-size: .26rem;

    }
    .error-message{
        margin-top: 0.08rem;
        text-align: center;
        font-size: 0.24rem;
        font-weight: 500;
    }
    .title{
        font-size: 24px;
        line-height: 1.2;
    }
    .input-container{
        margin: 20px 0 20px;
        text-align: center;
        padding-left: 0;
        .ui-input {
            font-size: 16px;
            width: 100%;
            line-height: 1.2;
            text-align: center;
            margin: 0;
        }
    }
    .success-content{
        margin-top: 0.4rem;
        .success-icon{
            color: #59CA46;
            font-size: 0.5rem;
            display: block;
            margin-right: 0 auto;
        }
        span {
            color: #63c622;
            display: block;
            font-size: .26rem;
            font-weight: 500;
            margin-top: .1rem;
        }
    }
}
</style>
